module.exports = __webpack_public_path__ + "static/img/app_bg5.ca0b353.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app_bg5.jpg
// module id = Ulfk
// module chunks = 0